export enum breakpoint {
  tiny = 320,
  xsmall = 359,
  small = 480,
  tablet = 560,
  medium = 768,
  large = 1000,
  contentMaxWidth = 1200,
  extraLarge = 1240,
  jumbo = 2000,
  huge = 2400,
}

export const mediaQuery: {
  tiny: string;
  xsmall: string;
  small: string;
  tablet: string;
  medium: string;
  large: string;
  extralarge: string;
  jumbo: string;
  huge: string;
  custom: (breakpoint: number) => string;
} = {
  tiny: `(max-width: ${breakpoint.tiny}px)`,
  xsmall: `(max-width: ${breakpoint.xsmall}px)`,
  small: `(max-width: ${breakpoint.small}px)`,
  tablet: `(max-width: ${breakpoint.tablet}px)`,
  medium: `(max-width: ${breakpoint.medium}px)`,
  large: `(max-width: ${breakpoint.large}px)`,
  extralarge: `(max-width: ${breakpoint.extraLarge}px)`,
  jumbo: `(max-width: ${breakpoint.jumbo}px)`,
  huge: `(max-width: ${breakpoint.huge}px)`,
  custom: (breakpoint) => `(max-width: ${breakpoint}px)`,
};

export const mediaQueryMin: {
  tiny: string;
  xsmall: string;
  small: string;
  tablet: string;
  medium: string;
  large: string;
  extralarge: string;
  jumbo: string;
  huge: string;
  custom: (breakpoint: number) => string;
} = {
  tiny: `(min-width: ${breakpoint.tiny}px)`,
  xsmall: `(min-width: ${breakpoint.xsmall}px)`,
  small: `(min-width: ${breakpoint.small}px)`,
  tablet: `(min-width: ${breakpoint.tablet}px)`,
  medium: `(min-width: ${breakpoint.medium}px)`,
  large: `(min-width: ${breakpoint.large}px)`,
  extralarge: `(min-width: ${breakpoint.extraLarge}px)`,
  jumbo: `(min-width: ${breakpoint.jumbo}px)`,
  huge: `(min-width: ${breakpoint.huge}px)`,
  custom: (breakpoint) => `(min-width: ${breakpoint}px)`,
};
